import { fixUniquePathsForAllChildren } from "@/components/Canvas/Storyboard/StaticIframe/utils/navTreeLookupUtils";
import { JsxElement, JsxElementType } from "@/utils/jsx/jsxElementTypes";
import { TempoElement } from "@/utils/tempoElement";
import { NavTreeNode } from "@/utils/types";

export const getFileKeyForComponent = (
  component: JsxElement,
  canvasId: string,
) => {
  let fileKey = "";

  if (component.filename) {
    fileKey = component.filename.split(canvasId + "/")[1] || "";

    if (component.type === JsxElementType.StorybookComponent) {
      fileKey += `/${component.componentName}`;
    }
  }

  return fileKey;
};

const cloneNavTreeNode = (
  node: NavTreeNode,
  parent: NavTreeNode | undefined,
  storyboardId: string,
): NavTreeNode => {
  const clonedNode: NavTreeNode = {
    parent,
    children: [],
    tempoElement: new TempoElement(
      node.tempoElement.codebaseId,
      storyboardId,
      node.tempoElement.uniquePath, // Will be fixed by fixUniquePathsForAllChildren
    ),
    name: node.name,
    elementTagName: node.elementTagName,
    isComponent: node.isComponent,
    level: node.level,
    classList: node.classList ? [...node.classList] : undefined,
    props: node.props ? { ...node.props } : undefined,
    literalChildren: node.literalChildren
      ? [...node.literalChildren]
      : undefined,
    domUniquePath: node.domUniquePath, // Will be fixed by fixUniquePathsForAllChildren
  };

  // Clone all children recursively
  if (node.children) {
    clonedNode.children = node.children.map((child) =>
      cloneNavTreeNode(child, clonedNode, storyboardId),
    );
  }

  return clonedNode;
};

export const getAssetNavTreeWithoutShell = (navTree: NavTreeNode) => {
  function searchForAssetRoot(node: NavTreeNode): NavTreeNode | null {
    if (node.props?.["data-tempo-asset-container"] !== undefined) {
      return node;
    }
    for (const child of node.children) {
      const found = searchForAssetRoot(child);
      if (found) return found;
    }
    return null;
  }

  const assetRoot = searchForAssetRoot(navTree);
  if (!assetRoot) return [navTree];
  // TODO fix this to natively support multiple nav trees
  if (assetRoot.children.length > 1) {
    const navTree = cloneNavTreeNode(
      assetRoot,
      undefined,
      assetRoot.tempoElement.storyboardId,
    );
    fixUniquePathsForAllChildren(navTree);
    return [navTree];
  }
  return assetRoot.children.map((child) => {
    const navTree = cloneNavTreeNode(
      child,
      undefined,
      assetRoot.tempoElement.storyboardId,
    );
    fixUniquePathsForAllChildren(navTree);
    return navTree;
  });
};
